import { ColorPicker } from "@frends/ui-components/react";

export default ColorPicker;
